import {
  ErrorResponse,
  getConstraintErrorResponse,
  getErrorResponse,
  getErrorResponseFromCode,
  isAuthError,
  isBadRequest
} from '../base/apiErrorHandler'

/**
 * Composable face of base/apiErrorHandler, so the transport modules in stage 3 can spread it
 * into their returned bag the way AuthorBase's services spread their generic composables.
 */
export function useApiErrorHandler () {
  return {
    getErrorResponse,
    getErrorResponseFromCode,
    getConstraintErrorResponse,
    isBadRequest,
    isAuthError
  }
}

export type { ErrorResponse }
